import { Box, Stack } from '@dtx-company/design-system/src'
import { LOCG_DESIGN_SECTIONS } from '../../LoggedOutCodeGenerator.constants'
import { forwardRef } from 'react'
import { selectDesignFirst } from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import { useSelector } from '@xstate/react'
import dynamic from 'next/dynamic'

const BackButton = dynamic(() => import('../../BackButton/BackButton').then(mod => mod.BackButton))

export const CodeDesign = forwardRef<HTMLDivElement[]>((_props, ref) => {
  const { isTabletOrDesktop } = useScreenSizeBreakpoints()
  const { locgService } = useGlobalServices()
  const designFirst = useSelector(locgService, selectDesignFirst)

  return (
    <>
      {isTabletOrDesktop && !designFirst && <BackButton />}
      <Stack gap={{ xs: 8, md: 16 }} sx={{ width: '100%' }}>
        {LOCG_DESIGN_SECTIONS.map(({ id, Component }, i) => (
          <Box
            key={id}
            id={id}
            ref={(el: HTMLDivElement) => {
              if (ref && 'current' in ref) {
                ref.current = ref.current || []
                ref.current[i] = el
              }
            }}
            sx={theme => ({
              maxWidth: {
                md: theme.spacing(136)
              }
            })}
          >
            <Component />
          </Box>
        ))}
      </Stack>
    </>
  )
})

CodeDesign.displayName = 'CodeDesign'
